// DA-12966: легенда слоя потерянных самокатов (LOST / DELETED) с переключателями
import { i18n } from '@lingui/core';
import { t } from '@lingui/macro';
import classnames from 'classnames';
import { connect } from 'react-redux';
import React, { Fragment } from 'react';
import { onChangeLostDevicesFilter, onToggleLostDevicesServiceCenter } from '../../../ac/onChangeMapFilters';
import { LostDevicesStatuses } from '../../../constants/variables';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import { LegendIconRenderer } from '../../LegendRenderer/LegendIconRenderer';
import { LEGEND_ICON_TYPES } from '../../../types/legendTypes';
import styles from '../FilterSidebar.module.css';

const LostDevicesLegendComponent = ({ mapFilters, onChangeLostDevicesFilter, onToggleLostDevicesServiceCenter }) => (
    <div>
        <div className={styles.legHead}>{t`Потерянные самокаты:`}</div>
        <div className={styles.checkboxIconGrid}>
            {LostDevicesStatuses.map(({ value, color, label }) => (
                <Fragment key={value}>
                    <LegendIconRenderer
                        type={LEGEND_ICON_TYPES.CIRCLE}
                        color={color}
                        size="2vw"
                        opacity={0.85}
                    />
                    <label htmlFor={value}>{i18n._(label)}</label>
                    <div>
                        <label className={styles.switch}>
                            <input
                                type='checkbox'
                                id={value}
                                value={value}
                                checked={mapFilters.lostDevicesStatuses.includes(value)}
                                onChange={onChangeLostDevicesFilter}
                            />
                            <span className={classnames(styles.sliderRound, styles.slider)} />
                        </label>
                    </div>
                </Fragment>
            ))}
        </div>
        <div
            className={styles.checkboxIconGrid}
            style={{ marginTop: '8px' }}
        >
            {/* белый кружок с синей обводкой — символ потерь у СЦ */}
            <svg
                width="2vw"
                height="2vw"
                viewBox="13 13 24 24"
                style={{ display: 'block' }}
            >
                {/* белая подложка — на всю иконку, как у circle.svg */}
                <circle
                    cx="25"
                    cy="25"
                    r="12"
                    fill="white"
                    opacity="0.85"
                />
                {/* синяя обводка с зазором ~1.75px от края подложки */}
                <circle
                    cx="25"
                    cy="25"
                    r="9"
                    fill="none"
                    stroke="#3b82f6"
                    strokeWidth="2.5"
                />
            </svg>
            <label htmlFor="lostDevicesShowServiceCenter">{t`Потери в Сервис Центрах`}</label>
            <div>
                <label className={styles.switch}>
                    <input
                        type='checkbox'
                        id="lostDevicesShowServiceCenter"
                        checked={mapFilters.lostDevicesShowServiceCenter}
                        onChange={onToggleLostDevicesServiceCenter}
                    />
                    <span className={classnames(styles.sliderRound, styles.slider)} />
                </label>
            </div>
        </div>
    </div>
);
const mapStateToProps = ({ mapFilters }) => ({ mapFilters });
const ConnectedComponent = connect(mapStateToProps, { onChangeLostDevicesFilter, onToggleLostDevicesServiceCenter })(LostDevicesLegendComponent);

export const LostDevicesLegend = withDisplayedLayersCheck(
    ConnectedComponent,
    'Потерянные самокаты'
);
